import React from "react";
import videojs from "video.js";
import styled from "styled-components";
import "./styles.scss";
// import "video.js/dist/video-js.css";

export default class VideoPlayer extends React.Component {
  componentDidMount() {
    this.player = videojs(this.videoNode, this.props, function onPlayerReady() {
      console.log("onPlayerReady", this);
    });
  }

  componentWillUnmount() {
    if (this.player) {
      this.player.dispose();
    }
  }

  render() {
    return (
      <PlayerWrapper data-vjs-player>
        <video
          id="my_video_1"
          className="video-js vjs-default-skin vjs-big-play-centered"
          controls
          ref={(node) => (this.videoNode = node)}
          // poster={this.props.thumbnail}
          data-setup='{ "aspectRatio":"16:9", "autoplay":true, "playbackRates": [1, 1.5, 2] }'
        >
          <source src={this.props.src} type="video/mp4" />
        </video>
      </PlayerWrapper>
    );
  }
}

VideoPlayer.defaultProps = {
  src: "https://vjs.zencdn.net/v/oceans.mp4",
  thumbnail:
    "https://justact-api-uploads.s3.ap-south-1.amazonaws.com/160/1700823412193-01adb6b5-9feb-4195-8154-962bcdf42723/Asset%202%404x-100.jpg",
};
const PlayerWrapper = styled.div``;
